<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="body-select-device-modal-list">
      <span class="description">Selecione dispositivo que deseja configurar:</span>
      <div class="filters">
        <div class="row align">
          <div class="col-10">
            <mat-form-field appearance="outline">
              <mat-icon matPrefix class="my-icon">search</mat-icon>
              <mat-label>Pesquisar</mat-label>
              <input matInput type="text" id="searchText" name="searchText" [(ngModel)]="searchText"
                (keyup)="onKeySearch()">
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-icon matTooltip="Recarregar" class="option-icon" (click)="scanDevices()">sync</mat-icon>
            </div>
          </div>
        </div>
        @if (isConnecting || isScanning) {
          <span class="span-gif">
            <img class="connection-gif" src="assets/images/bluetooth-search.gif" >
            @if (isScanning) {
              <span>Buscando...</span>
            }
            @if (isConnecting) {
              <span>Conectando...</span>
            }
          </span>
        }
        @if (!isConnecting) {
          <div class="body-select-device-modal-list__options">
            @for (item of listDeviceDisplay; track item) {
              <div mat-flat-button color="accent" class=" body-select-device-modal-list__options--buttons"
                (click)="selectItem(item)">
                <span class="option-name truncate">{{item.name}} - {{item.address}} </span>
                <mat-icon class="option-icon">navigate_next</mat-icon>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>